import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'underscore';

const useRole = ({ action, module, controller, contract_id, type, value }) => {
  const { role_list } = useSelector((state) => (state && state[type]) || []);
  const _action = action || ['get', 'get_list', 'delete', 'update', 'add'];

  const roleChecker = useCallback(
    _action.map((_a) => ({
      action: _a,
      // contract_id : (contract_id || null),
      ctrl: controller,
      module: module,
      type: type.toUpperCase(),
      // value : value || null,
    })),
    [_action]
  );

  const actionRole = useCallback(
    roleChecker.filter(
      (role) =>
        (role_list || []).filter((_role) => _.isEqual(_role, role)).length > 0
    ),
    [roleChecker]
  );

  return useCallback(
    [
      _action.reduce((acc, cur, idx) => {
        acc[cur] = actionRole.filter((role) => role.action === cur).length > 0;
        return acc;
      }, {}),
    ],
    [role_list]
  );
};

export default useRole;
